export class RemoveFilterSuccessAction {
    public static readonly type = '[JobsPlacements] Remove filter success';

    constructor(public payload: unknown) { }
}
